import React from "react";
import axios from 'axios'

class LinkTracker extends React.Component {
    async componentDidMount() {
        let refNo = this.props.match.params.refNo;
        if (refNo) {
            axios.get('./api/linktracker/' + refNo)
            .then(res => {
                if(res.data) {
                    window.location.replace(res.data.url);
                }
            })
            .catch(err => {
                window.location.replace("https://inadra.se/jirango/");
            })
        }
        else {
            window.location.replace("https://inadra.se/jirango/");
        }
    }
    render() {
        return <div />
    }
}
export default LinkTracker;
